module.exports = __webpack_public_path__ + "static/img/WEIS_H5.ce434ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/WEIS_H5.png
// module id = 0UJj
// module chunks = 34